import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/rates
    */
    getRates: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/rates',{
            params:{
                offset:options.offset,
                itemsPerPage:options.itemsPerPage,
                orderBy:options.orderBy,
                orderDirection:options.orderDirection,
                showDeleted:options.showDeleted,
                selectedYear:options.selectedYear
        }});
    },

    /*
        GET     /api/rates/search
    */
   searchRates: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/rates/search',{
        params:{
            showDeleted:options.showDeleted,
            selectedYear:options.selectedYear,
            filterableHeaders:options.filterableHeaders,
            q:options.q
    }});
},

  /*
		POST 	/api/rates/copy
	*/
    postCopyRates: function( source,destination){
        return axios.post( LOGUS_CONFIG.API_URL + '/rates/copy',
            {
                source: source,
                destination:destination,
            }
        );
    },

    /*
		POST 	/api/rates
	*/
    postAddNewRate: function( name,category,free,tolerance,mealsFromJournal,hasBreakfast,hasLunch,hasTea, year_id, monthly,monthlyNP,monthlyMeal,monthlyOther,hour,overtime,breakfast,lunch,tea,other,hourNP,breakfastNP,lunchNP,teaNP,otherNP ){
        return axios.post( LOGUS_CONFIG.API_URL + '/rates',
            {
                name: name,
                category:category,
                free: free,
                tolerance:tolerance,
                mealsFromJournal:mealsFromJournal,
                hasBreakfast:hasBreakfast,
                hasLunch: hasLunch,
                hasTea:hasTea,
                year_id:year_id,
                monthly:monthly,
                monthlyNP:monthlyNP,
                monthlyMeal:monthlyMeal,
                monthlyOther:monthlyOther,
                hour:hour,
                overtime:overtime,
                breakfast:breakfast,
                lunch:lunch,
                tea:tea,
                other:other,
                hourNP:hourNP,
                breakfastNP:breakfastNP,
                lunchNP:lunchNP,
                teaNP:teaNP,
                otherNP:otherNP
            }
        );
    },

    /*
		GET 	/api/rates/{slug}/edit
	*/
    getRateEdit: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/rates/' + slug + '/edit' );
	},

    /*
		PUT 	/api/rates/{slug}
	*/
    putEditRate: function(slug, name,category,free,tolerance,mealsFromJournal,hasBreakfast,hasLunch,hasTea,year_id,monthly,monthlyNP,monthlyMeal,monthlyOther,hour,overtime,breakfast,lunch,tea,other,hourNP,breakfastNP,lunchNP,teaNP,otherNP){
        return axios.put( LOGUS_CONFIG.API_URL + '/rates/'+ slug,
            {
                name: name,
                category:category,
                free: free,
                tolerance:tolerance,
                mealsFromJournal:mealsFromJournal,
                hasBreakfast:hasBreakfast,
                hasLunch: hasLunch,
                hasTea:hasTea,
                year_id:year_id,
                monthly:monthly,
                monthlyNP:monthlyNP,
                monthlyMeal:monthlyMeal,
                monthlyOther:monthlyOther,
                hour:hour,
                overtime:overtime,
                breakfast:breakfast,
                lunch:lunch,
                tea:tea,
                other:other,
                hourNP:hourNP,
                breakfastNP:breakfastNP,
                lunchNP:lunchNP,
                teaNP:teaNP,
                otherNP:otherNP
            }
        );
    },

     /*
		GET 	/api/rates/reactivate/{slug}
	*/
    putReactivateRate: function(slug){
        return axios.get( LOGUS_CONFIG.API_URL + '/rates/reactivate/' + slug);
    },

    /*
		DELETE /api/rates/{slug}
	*/
    deleteRate: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/rates/' + slug );
    },
    
    /*
		DELETE /api/rates/{slug}/force
	*/
    forceDeleteRate: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/rates/' + slug + '/force' );
	}
}